@if (tileStates().length > 1) {
  <ziro-service-tile-edit-multi
    [attr.data-automation]="tileStates()[0].dataAutomation + '-multi-edit-tile'"
    [serviceName]="
      tileStates()[0].serviceType === tiles.DESKPHONE ? 'tkey;shared.model.deskphone.text' : tileStates()[0].serviceName
    "
    [description]="getMultiTileDescription(tileStates()[0], tileStates().length)"
    [icon]="tileStates()[0].icon"
  >
    @for (tileState of tileStates(); track tileState; let i = $index) {
      <ziro-service-tile
        [isDeskPhone]="tileState.serviceType === tiles.DESKPHONE"
        [attr.data-automation]="tileState.dataAutomation"
        [dataAutomation]="tileState.dataAutomation"
        [serviceType]="tileState.serviceType"
        [tileType]="tileState.tileType"
        [serviceName]="tileState.serviceName"
        [icon]="tileState.icon"
        [description]="tileState.description"
        [isAdding]="tileState.isAdding"
        [isDeleting]="tileState.isDeleting"
        [isDeleted]="tileState.isDeleted"
        [isEnabled]="tileState.isEnabled"
        [isDisplayed]="tileState.isDisplayed"
        [tooltip]="tileState.tooltip"
        [phone]="
          tileState.serviceType === tiles.DESKPHONE && tileState.service
            ? { name: tileState.service['name'], serverId: tileState.service['serverId'] }
            : null
        "
        (editDeskPhoneAddClicked)="onAddTileClicked(tileState, i)"
        (multiEditAddClicked)="onAddTileClicked(tileState, i)"
        (addTileClicked)="onAddTileClicked(tileState, i)"
        (editTileClicked)="onEditTileClicked(tileState, i)"
        (editTileDeleteClicked)="onEditTileDeleteClicked(tileState, i)"
        (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileState, i)"
        (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileState, i)"
        (editDeskPhoneCopyClicked)="onCopyDeskphoneClicked(tileState, i)"
      ></ziro-service-tile>
    }
  </ziro-service-tile-edit-multi>
}
@if (tileStates().length === 1) {
  <div>
    @for (tileState of tileStates(); track tileState; let i = $index) {
      <ziro-service-tile
        [isDeskPhone]="tileState.serviceType === tiles.DESKPHONE"
        [attr.data-automation]="tileState.dataAutomation"
        [dataAutomation]="tileState.dataAutomation"
        [serviceType]="tileState.serviceType"
        [tileType]="tileState.tileType"
        [serviceName]="tileState.serviceName"
        [icon]="tileState.icon"
        [description]="tileState.description"
        [isAdding]="tileState.isAdding"
        [isDeleting]="tileState.isDeleting"
        [isDeleted]="tileState.isDeleted"
        [isEnabled]="tileState.isEnabled"
        [isDisplayed]="tileState.isDisplayed"
        [tooltip]="tileState.tooltip"
        [phone]="
          tileState.serviceType === tiles.DESKPHONE && tileState.service
            ? { name: tileState.service['name'], serverId: tileState.service['serverId'] }
            : null
        "
        (editDeskPhoneAddClicked)="onAddTileClicked(tileState, i)"
        (multiEditAddClicked)="onAddTileClicked(tileState, i)"
        (addTileClicked)="onAddTileClicked(tileState, i)"
        (editTileClicked)="onEditTileClicked(tileState, i)"
        (editTileDeleteClicked)="onEditTileDeleteClicked(tileState, i)"
        (deleteTileConfirmButtonClicked)="onDeleteTileConfirmButtonClicked(tileState, i)"
        (deleteTileCancelButtonClicked)="onDeleteTileCancelButtonClicked(tileState, i)"
        (editDeskPhoneCopyClicked)="onCopyDeskphoneClicked(tileState, i)"
      ></ziro-service-tile>
    }
  </div>
}
